import { commonStyles, buttonStyle } from 'src/Library/CommonStyles';
import { tokens } from 'src/design-system';

export const InquiryConfirmationModalStyles = (theme) => ({
  modal: {
    minWidth: '580px',
    '& .ant-modal-body': {
      padding: `${tokens.spacing.md}px ${tokens.spacing.lg}px 40px ${tokens.spacing.lg}px`,
      color: tokens.colors.textSecondary,
      fontSize: tokens.fontSize.small,
    },
    '& .ant-modal-footer': {
      borderTop: 0,
      fontSize: tokens.fontSize.small,
    },
  },
  createNewButton: {
    ...buttonStyle(tokens.colors.bgWhite, tokens.colors.primaryDark, `1px solid ${tokens.colors.primaryDark}`),
    fontSize: tokens.fontSize.small,
    borderRadius: tokens.radius.sm,
    marginLeft: tokens.spacing.lg,
  },
  cancelButton: {
    color: '#666666',
    cursor: 'pointer',
  },
  searchInfo: {
    margin: `${tokens.spacing.ms}px 0px`,
    padding: `${tokens.spacing.ms}px 0px`,
    fontWeight: tokens.fontWeight.semibold,
    ...commonStyles(theme).flexRow,
  },
  line: {
    display: 'flex',
    flex: 1,
    height: 1,
    backgroundColor: '#999999',
  },
  dot: {
    height: '6px',
    width: '6px',
    borderRadius: '5px',
    display: 'inline-block',
    border: '1px solid #999999',
  },
  lineAndDot: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  product: {
    fontWeight: 'normal',
    fontSize: tokens.fontSize.caption,
    ...commonStyles(theme).ellipses,
    maxWidth: '145px',
  },
  cargoDetails: {
    ...commonStyles(theme).flexRow,
  },
  responseCount: {
    marginLeft: tokens.spacing.sm,
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
  },
  labelColor: {
    color: '#666666',
    fontSize: tokens.fontSize.caption,
  },
  inquiryCard: {
    padding: `${tokens.spacing.ms}px ${tokens.spacing.md}px`,
    backgroundColor: '#FAFAFA',
    borderRadius: tokens.radius.md,
    margin: `${tokens.spacing.sm}px 0px`,
    ...commonStyles(theme).flexRow,
  },
  inquiryNo: {
    fontSize: tokens.fontSize.h3,
    fontWeight: tokens.fontWeight.semibold,
  },
  cardBorder: {
    textAlign: 'center',
    borderRight: `1px solid ${tokens.colors.border}`,
  },
  deadline: {
    fontSize: tokens.fontSize.caption,
    color: '#666666',
    marginLeft: '6px',
  },
  port: {
    ...commonStyles(theme).flexRow,
    justifyContent: 'space-between',
  },
  ffModal: {
    width: '460px !important',
    '& .ant-modal-content': {
      minHeight: '506px',
    },
    padding: `${tokens.spacing.lg}px ${tokens.spacing.md}px`,
    '& .ant-modal-body': {
      color: tokens.colors.textSecondary,
      fontSize: tokens.fontSize.small,
    },
    '& .ant-modal-footer': {
      fontSize: tokens.fontSize.small,
      position: 'absolute',
      bottom: 0,
      right: 0,
      width: '100%',
    },
  },
  nextButton: {
    ...buttonStyle(tokens.colors.bgWhite, tokens.colors.primary, `1px solid ${tokens.colors.primary}`),
  },
  cancelFFButton: {
    ...buttonStyle('#424242', '#F2F4F6', '1px solid #DDE0E5'),
    marginRight: tokens.spacing.sm,
  },
  status: {
    fontSize: tokens.fontSize.caption,
    fontStyle: 'italic',
    color: '#999999',
    textAlign: 'right',
    paddingRight: tokens.spacing.sm,
  },
  ffRow: {
    ...commonStyles(theme).flexRow,
    margin: `${tokens.spacing.sm}px 0`,
  },
  closeIcon: {
    textAlign: 'right',
    color: '#595959',
  },
  selectFF: {
    color: tokens.colors.primary,
    cursor: 'pointer',
  },
  selectAnotherFF: {
    padding: `0 0 ${tokens.spacing.ms}px 0`,
  },
  group: {
    marginLeft: '21px',
    backgroundColor: '#FAFAFA',
    border: '1px solid #F7F7F7',
    borderRadius: tokens.radius.md,
    padding: tokens.spacing.xxs,
    fontSize: tokens.fontSize.caption,
  },
  ffOptions: {
    ...commonStyles(theme).justifySpaceBetween,
    width: '100%',
  },
  anotherFFs: {
    ...commonStyles(theme).justifySpaceBetween,
    margin: `${tokens.spacing.xs}px 0`,
  },
  ffList: {
    ...commonStyles(theme).fixedScrollbar,
    maxHeight: '120px',
    overflow: 'auto',
  },
  portDiv: {
    ...commonStyles(theme).justifySpaceBetween,
    alignItems: 'center',
    height: '25px',
    flexDirection: 'column',
    width: '100%',
    marginBottom: '54px',
  },
  lineStyle: {
    ...commonStyles(theme).flexRow,
    marginBottom: tokens.spacing.sm,
    width: '71%',
  },
  polDiv: {
    ...commonStyles(theme).flexColumn,
    alignItems: 'center',
    width: '76px',
  },
  pol: {
    ...commonStyles(theme).flexColumn,
    left: '22px',
    width: '80px',
    alignItems: 'center',
  },
  polName: {
    ...commonStyles(theme).ellipses,
    color: '#262626',
    fontSize: tokens.fontSize.body,
    fontWeight: tokens.fontWeight.semibold,
    maxWidth: '150px',
    textAlign: 'center',
  },
  pod: {
    ...commonStyles(theme).flexColumn,
    right: '100px',
    width: '80px',
    alignItems: 'center',
  },
  portFlag: {
    width: '27px',
    height: '19px',
  },
  sendInquiryModal: {
    width: '400px !important',
    '& .ant-modal-body': {
      paddingBottom: 0,
      color: tokens.colors.textSecondary,
    },
  },
  selectedFFs: {
    borderTop: '1px solid rgba(0,0,0,0.09)',
    padding: `${tokens.spacing.sm}px 0`,
    fontWeight: tokens.fontWeight.semibold,
  },
  confirmationRoute: {
    ...commonStyles(theme).flexRow,
    fontSize: tokens.fontSize.small,
    marginBottom: '18px',
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.textSecondary,
  },
  confirmationTitle: {
    fontSize: tokens.fontSize.body,
    ...commonStyles(theme).flexRow,
  },
  okButton: {
    marginTop: tokens.spacing.xxl,
    textAlign: 'center',
  },
  portRoute: {
    ...commonStyles(theme).flexRow,
    justifyContent: 'space-between',
    width: '100%',
  },
  showAll: {
    color: tokens.colors.primary,
    cursor: 'pointer',
    marginBottom: tokens.spacing.sm,
  },
  selectedFFsPanel: {
    ...commonStyles(theme).justifySpaceBetween,
    fontWeight: tokens.fontWeight.semibold,
  },
  collapseDiv: {
    border: 0,
    backgroundColor: 'unset',
    color: tokens.colors.textSecondary,
    '& .ant-collapse-header': {
      fontWeight: tokens.fontWeight.semibold,
      padding: '12px 10px !important',
      paddingLeft: '24px !important',
      '& .ant-collapse-arrow': {
        left: '0 !important',
      },
    },
    '& .ant-collapse-content': {
      borderTop: 0,
      padding: '0 10px 0 24px',
      '& .ant-collapse-content-box': {
        padding: 0,
      },
    },
  },
  select: {
    '& .ant-select-selection': {
      fontSize: tokens.fontSize.small,
    },
  },
  ffSelectionBorder: {
    borderTop: '0.5px solid #d9d9d9',
    borderBottom: '0',
  },
});
